import {DATA_STATE} from "../../users/contexts/UsersDashboardContext";
import {SelectInputOption} from "@vebox/etui-core";
import {ValidatedEquipmentModalElementProps} from "./components/ValidatedEquipmentModalElement";

export interface LockUnlockReason {
    value: string;
    key: string
}

export interface LockUnlockReasons {
    equipmentLockReasons: LockUnlockReason[];
    equipmentUnlockReasons: LockUnlockReason[]
}

export enum EMAIL_REASON {
    FILE_ELABORATION = "FILE_ELABORATION",
    CAMPAIGN_REPORT = "CAMPAIGN_REPORT",
}

export interface EmailReceiver {
    emailNotification: boolean,
    emailReason: EMAIL_REASON
}

export interface AvailableMassivePatch {
    name: MassiveActions
    patch: string,
    value: string[],
    available: boolean
    emailReceivers: EmailReceiver[]
}

export interface JSONAvailableMassivePatch {
    op: "ADD"
    path: string,
    value: string,
}

export enum MassiveActions {
    PACKAGES_CLAIM = "packagesClaim",
    EQUIPMENT_DELETION = "equipmentDeletion",
    LOCATIONS_DELETION = "locationsDeletion",
    LOCK_UNLOCK_EQUIPMENT_COMPRESSOR = "lockUnlockEquipmentCompressor",
    CHANGE_EQUIPMENT_STATUS = "changeEquipmentStatus",
    EQUIPMENT_HEART_BEAT = "equipmentHeartBeat",
    CENSUS_COOLER = "censusCooler"
}

export enum lockUnlockReasonsEnum {
    LOCK_REASONS = "LOCK_REASONS",
    UNLOCK_REASONS = "UNLOCK_REASONS"
}

export interface ValidateEquipment {
    code: string,
    guid: string,
    valid: boolean
}

export interface EquipmentStatus {
    value: string,
    key: string,
}

export interface AvailableMassivePatchesInfo {
    availableMassiveState: DATA_STATE,
    availableMassivePatches: AvailableMassivePatch[]
}

export interface MassiveActionsControllerProps {
    massiveAction: MassiveActions
    stackManager: any
}

export interface ValueInfo {
    valueInfo: {
        massiveAction: MassiveActions.LOCK_UNLOCK_EQUIPMENT_COMPRESSOR,
        lockReasonGuid: string,
        lockOperation: lockUnlockReasonsEnum
    } | {
        massiveAction: MassiveActions.CHANGE_EQUIPMENT_STATUS,
        equipmentStatusGuid: string,
    } | {
        massiveAction: MassiveActions.EQUIPMENT_HEART_BEAT,
    }
}


export const prepareInfoModalItems = (foundItem: { title: string, description: string },
                                      notFoundItem: {
                                          title: string,
                                          description: string
                                      }): ValidatedEquipmentModalElementProps[] => {
    return [{
        statusTitle: foundItem.title,
        statusDescription: foundItem.description
    }, {
        statusTitle: notFoundItem.title,
        statusDescription: notFoundItem.description,
        statusIconName: "priority_high",
        itemClassName: "not-found"
    }]
}

export const equipmentsStatusesToSelectInputOption = (reasons: EquipmentStatus[]): SelectInputOption[] => {
    return reasons.map((reason) => {
        return {
            value: reason.key,
            label: reason.value
        }
    })
}

export const prepareMassiveAction = (validatedEquipmentGuids: string[],
                                     availableMassivePatches: AvailableMassivePatch[],
                                     valueInfo: ValueInfo): JSONAvailableMassivePatch[] => {
    const patches: JSONAvailableMassivePatch[] = [];
    const valueType = valueInfo.valueInfo;
    const patch = availableMassivePatches.find(availablePatch => availablePatch.name === valueType.massiveAction);

    if (!patch.available) {
        return [];
    }

    let value = "";
    if (valueType?.massiveAction === MassiveActions.LOCK_UNLOCK_EQUIPMENT_COMPRESSOR) {
        if (valueType.lockOperation === lockUnlockReasonsEnum.LOCK_REASONS) {
            value = `lock/${valueType.lockReasonGuid}`
        }
        if (valueType.lockOperation === lockUnlockReasonsEnum.UNLOCK_REASONS) {
            value = `unlock/${valueType.lockReasonGuid}`
        }
    }
    if (valueType?.massiveAction === MassiveActions.CHANGE_EQUIPMENT_STATUS) {
        value = valueType.equipmentStatusGuid
    }
    if (valueType?.massiveAction === MassiveActions.EQUIPMENT_HEART_BEAT) {
        value = patch.value[0];
    }
    validatedEquipmentGuids.forEach((guid) => {
        patches.push({
            op: "ADD",
            value,
            path: patch.patch.replace("{equipmentGuid}", guid)
        })
    })
    return patches
}


export const getMassiveAction = (operationName: string): MassiveActions => {
    for (const action in MassiveActions) {
        if (MassiveActions[action] === operationName.replace("/", '')) {
            return MassiveActions[action]
        }
    }
    return undefined
}

export const getMassivePatch = (patchName: MassiveActions,
                                availableMassivePatches: AvailableMassivePatch[]): AvailableMassivePatch => {
    return availableMassivePatches.find(patch => patch.name === patchName)
}